import { render, staticRenderFns } from "./TemplatePerms.vue?vue&type=template&id=57a2236c"
import script from "./TemplatePerms.vue?vue&type=script&lang=js"
export * from "./TemplatePerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports